/** Values accepted when recording or updating a person's gender. */
export const MEMBER_GENDERS = ['female', 'male'] as const;
export type MemberGender = (typeof MEMBER_GENDERS)[number];

/** Stored gender codes, including legacy values still present in older records. */
export type StoredGenderCode = MemberGender | 'other' | 'prefer_not_to_say';

/** Profile rule sentinel — match people of any gender. */
export const GENDER_RULE_ANY = '*' as const;

type Translate = (key: string) => string;

export const memberGenderListboxOptions = (t: Translate) =>
  MEMBER_GENDERS.map((value) => ({
    value,
    label: t(`members.gender.${value}`),
  }));

export const genderRuleListboxOptions = (tGroups: Translate, tPeople: Translate) => [
  { value: GENDER_RULE_ANY, label: tGroups('audience.genderAny') },
  { value: 'female', label: tPeople('members.gender.female') },
  { value: 'male', label: tPeople('members.gender.male') },
  { value: 'other', label: tPeople('members.gender.other') },
  { value: 'prefer_not_to_say', label: tPeople('members.gender.prefer_not_to_say') },
];

export const isMemberGender = (value: string | null | undefined): value is MemberGender =>
  value === 'female' || value === 'male';
